/* =============================================
   Marché Collage : vague 1 des maquettes par type de page (28/09/2026, go d'Antonio)
   Maquettes : ~/Desktop/NKOSI_Rebranding_2026/site/maquettes_pages/ (00_sommaire, codes F1, F4, P2, P3).
   Outil de pose : tools/rebranding_site/vague1.py. Styles : nkosi-marche-collage.css, section V1.
   1. F1  Fiche : les lots de quantité (Moon Bundles) sous le bouton d'ajout, ouverts par défaut (Antonio, 28/09
          0 h 45), un bouton les replie.
   2. F4  Fiche sans avis : « Donner le premier avis » ouvre le formulaire Judge.me (widget masqué jusque-là).
   3. P2  « Pour atteindre 39 € » : tous les produits du MÊME RAYON que ceux du panier (250 au plus), meilleures ventes du rayon
          d'abord (28/09/2026, Antonio : « produits de la même collection, même catégorie, en mettant en avant les top
          ventes de cette même catégorie ») : rayon = collection de catégorie la plus précise du produit (hors pays et
          collections générales), lue par templates/product.nk-collections.liquid ; produits lus par
          templates/collection.nk-produits.liquid?sort_by=best-selling ; le mieux vendu qui suffit en premier ; jamais
          de plafond de prix (17 h) ; carrousel à flèches sur mobile et sur ordinateur ;
          dans le tiroir Moon Bundles et sur la page panier. Disparaît dès 39 €.
   4. P3  Page panier en mobile : le total de la barre fixe suit le panier (le bouton, lui, est tenu par
          nkosi-moon-cart.js : bloqué sous 39 € avec le montant qui manque).
   Aucune fausse urgence, aucun compte à rebours ; rien ne s'affiche si une donnée manque.
   ============================================= */
(function () {
  "use strict";
  if (!window.fetch || !window.MutationObserver) return;

  var MINIMUM = 3900;             /* centimes, commande minimum (Checkout Blocks), comme nkosi-moon-cart.js */
  var ECART_MAX = 1000;           /* jamais un produit qui dépasse l'écart de 10 € ou plus (maquette 04) */
  var MAX_CHOIX = 250;            /* 28/09/2026, 17 h (Antonio : « proposer tous les produits de la même catégorie ; on doit pouvoir scroller longtemps ») : tout le rayon, en carrousel à flèches */
  var RACINE = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var L = (document.documentElement.getAttribute("lang") || "fr").slice(0, 2).toLowerCase();
  if (["fr", "en", "de", "it"].indexOf(L) < 0) L = "fr";

  var TXT = {
    fr: { voir: "Voir les lots", masquer: "Masquer les lots", titre: "Pour atteindre 39 €", lie: "Va avec votre panier",
          vente: "Meilleure vente", top: "Top vente du rayon", rayon: "Du même rayon", suffit: "suffit", ajouter: "Ajouter", ajoute: "Ajouté", erreur: "Réessayer",
          precedent: "Produits précédents", suivant: "Produits suivants" },
    en: { voir: "See the bundles", masquer: "Hide the bundles", titre: "To reach €39", lie: "Goes with your cart",
          vente: "Best seller", top: "Top seller in this aisle", rayon: "Same aisle", suffit: "enough", ajouter: "Add", ajoute: "Added", erreur: "Try again",
          precedent: "Previous products", suivant: "Next products" },
    de: { voir: "Staffelpreise ansehen", masquer: "Staffelpreise ausblenden", titre: "Bis 39 €", lie: "Passt zu Ihrem Warenkorb",
          vente: "Bestseller", top: "Topseller im Regal", rayon: "Aus demselben Regal", suffit: "reicht", ajouter: "Hinzufügen", ajoute: "Hinzugefügt", erreur: "Erneut versuchen",
          precedent: "Vorherige Produkte", suivant: "Nächste Produkte" },
    it: { voir: "Vedere i lotti", masquer: "Nascondere i lotti", titre: "Per arrivare a 39 €", lie: "Va con il vostro carrello",
          vente: "Il più venduto", top: "Top vendite del reparto", rayon: "Dallo stesso reparto", suffit: "basta", ajouter: "Aggiungi", ajoute: "Aggiunto", erreur: "Riprova",
          precedent: "Prodotti precedenti", suivant: "Prodotti successivi" }
  };
  var T = TXT[L];

  function tous(racine, sel) { return Array.prototype.slice.call(racine.querySelectorAll(sel)); }
  function texte(el, v) { if (el && el.textContent !== v) el.textContent = v; }
  function euro(c) {
    try {
      return new Intl.NumberFormat(L === "fr" ? "fr-FR" : L, { style: "currency", currency: "EUR", minimumFractionDigits: (c % 100 === 0 ? 0 : 2) }).format(c / 100);
    } catch (e) { return (c / 100).toFixed(2).replace(".", ",") + " €"; }
  }
  function json(url) {
    return fetch(url, { credentials: "same-origin", headers: { Accept: "application/json" } }).then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    });
  }

  /* ---------- 1. F1 : lots sous le bouton, ouverts par défaut, repliables ---------- */
  function lots() {
    tous(document, ".yv-main-product-detail moonbundle-component").forEach(function (c) {
      var n = c.querySelectorAll(".moonbundle-option-wrapper").length;
      var b = null;
      for (var i = 0; i < c.children.length; i++) if (c.children[i].classList.contains("nk-v1-lots")) b = c.children[i];
      if (!c.querySelector(".moonbundle-box") || n < 2) { if (b) b.parentNode.removeChild(b); return; }
      if (!b) {
        b = document.createElement("button");
        b.type = "button";
        b.className = "nk-v1-lots";
        b.innerHTML = '<span class="nk-v1-lots__texte"></span><span class="nk-v1-lots__fleche" aria-hidden="true"></span>';
        c.appendChild(b);
      }
      var ouvert = !c.classList.contains("nk-v1-replie");
      texte(b.firstChild, ouvert ? T.masquer : T.voir);
      if (b.getAttribute("aria-expanded") !== String(ouvert)) b.setAttribute("aria-expanded", String(ouvert));
    });
  }
  document.addEventListener("click", function (e) {
    var b = e.target && e.target.closest && e.target.closest(".nk-v1-lots");
    if (!b) return;
    var c = b.closest("moonbundle-component");
    if (!c) return;
    c.classList.toggle("nk-v1-replie");
    lots();
  });

  /* ---------- 2. F4 : premier avis ---------- */
  function ouvrirAvis() {
    var w = document.getElementById("judgeme_product_reviews") || document.querySelector(".jdgm-widget.jdgm-review-widget");
    document.documentElement.classList.add("nk-v1-avis-ouvert");
    if (!w) return false;
    try { w.scrollIntoView({ behavior: "smooth", block: "start" }); } catch (x) { w.scrollIntoView(); }
    var essais = 0;
    (function essai() {
      var cible = tous(w, "button, a").filter(function (x) {
        return /écrire un avis|write a review|bewertung schreiben|recensione/i.test(x.textContent || "");
      })[0];
      if (cible) cible.click();
      else if (++essais < 24) setTimeout(essai, 250);
    })();
    return true;
  }
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var a = e.target.closest("[data-nk-v1-avis-premier]");
    var badge = !a && document.documentElement.classList.contains("nk-v1-sans-avis") &&
      !document.documentElement.classList.contains("nk-v1-avis-ouvert") && e.target.closest(".jdgm-prev-badge");
    if (!a && !badge) return;
    if (ouvrirAvis()) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  /* ---------- 3. P2 : « Pour atteindre 39 € » ---------- */
  var panier = null, demande = null, cache = {}, enCours = {};

  function lirePanier(force) {
    if (demande && !force) return demande;
    demande = json(RACINE + "cart.js").then(function (c) { panier = c; return c; }, function () { demande = null; return null; });
    return demande;
  }
  function signature(c) {
    return L + ":" + c.total_price + ":" + c.items.map(function (i) { return i.variant_id + "x" + i.quantity; }).sort().join(",");
  }
  function normaliser(p, source) {
    if (!p) return null;
    var v = (p.variants || []).filter(function (x) { return x.available !== false; })[0];
    if (!v || p.available === false) return null;
    var prix = typeof v.price === "string" ? Math.round(parseFloat(v.price) * 100) : v.price;
    var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || "";
    if (img && typeof img === "object") img = img.src || img.url || "";
    return { id: p.id, variante: v.id, nom: p.title, prix: prix, img: img, url: p.url || (RACINE + "products/" + p.handle), source: source };
  }
  /* rayon d'un produit : la collection de catégorie la plus précise (hors pays, cadeaux et collections générales),
     sinon la plus petite collection de pays ; lue par templates/product.nk-collections.liquid */
  var EXCLUS = /^(all|meilleures-ventes|promotions|nouveautes|epicerie-africaine-caribeenne-produits-exotiques)$|cadeau|moon|palier|obsolete/;
  var PAYS = /^(cuisine-|epicerie-|produits-caraibes)/;
  function texteJson(url) {
    return fetch(url, { credentials: "same-origin" }).then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.text();
    }).then(function (t) { return JSON.parse(t); });
  }
  function rayonDe(handle) {
    return texteJson(RACINE + "products/" + encodeURIComponent(handle) + "?view=nk-collections").then(function (r) {
      var cols = (r.collections || []).filter(function (x) { return x && x.h && !EXCLUS.test(x.h) && x.n > 1; });
      var parTaille = function (a, b) { return a.n - b.n; };
      var cat = cols.filter(function (x) { return !PAYS.test(x.h); }).sort(parTaille)[0];
      var pays = cols.filter(function (x) { return PAYS.test(x.h); }).sort(parTaille)[0];
      return (cat || pays || {}).h || null;
    }, function () { return null; });
  }
  function produitsDuRayon(h) {
    return texteJson(RACINE + "collections/" + encodeURIComponent(h) + "?view=nk-produits&sort_by=best-selling")
      .then(function (r) { return r.produits || []; }, function () { return []; });
  }
  function candidats(c) {
    var vus = {}, handles = [];
    c.items.slice().sort(function (a, b) { return b.final_line_price - a.final_line_price; }).forEach(function (i) {
      vus[i.product_id] = true;
      if (i.final_line_price > 0 && i.handle && handles.indexOf(i.handle) < 0) handles.push(i.handle);
    });
    return Promise.all(handles.slice(0, 3).map(rayonDe)).then(function (rayons) {
      var uniques = rayons.filter(function (h, k) { return h && rayons.indexOf(h) === k; });
      if (!uniques.length) uniques = ["meilleures-ventes"];
      return Promise.all(uniques.map(produitsDuRayon)).then(function (listes) {
        /* les rayons du panier sont entrelacés, chacun dans l'ordre de ses meilleures ventes */
        var sortie = [], pris = {};
        var max = Math.max.apply(null, listes.map(function (l) { return l.length; }).concat([0]));
        for (var k = 0; k < max; k++) {
          listes.forEach(function (l) {
            var p = l[k];
            if (!p || !p.dispo || vus[p.id] || pris[p.id] || !(p.prix > 0) || !p.variante) return;
            pris[p.id] = true;
            sortie.push({ id: p.id, variante: p.variante, nom: p.title, prix: p.prix, img: p.img, url: p.url, source: "rayon", rang: k });
          });
        }
        return sortie;
      });
    });
  }
  /* règle de la maquette 04, revue le 28/09/2026 à 17 h : tout le rayon (plus de plafond de prix, demande d'Antonio) ;
     le mieux vendu qui suffit à lui seul d'abord, puis les meilleures ventes du rayon dans l'ordre */
  function choisir(liste, ecart) {
    var ok = liste.slice();
    var choix = [], pris = {};
    function prendre(p) { if (p && !pris[p.id] && choix.length < MAX_CHOIX) { pris[p.id] = true; choix.push(p); } }
    var suffit = ok.filter(function (p) { return p.prix >= ecart; })[0];
    if (suffit) { suffit.suffit = true; prendre(suffit); }
    ok.forEach(prendre);
    return choix;
  }
  function suggestions(c) {
    var ecart = MINIMUM - c.total_price;
    if (ecart <= 0 || !c.item_count) return Promise.resolve([]);
    var cle = signature(c);
    if (cache[cle]) return Promise.resolve(cache[cle]);
    try {
      var s = JSON.parse(sessionStorage.getItem("nkV1Tous") || "null");
      if (s && s.cle === cle && Date.now() - s.t < 600000 && s.choix && s.choix.length) { cache[cle] = s.choix; return Promise.resolve(s.choix); }
    } catch (x) {}
    if (enCours[cle]) return enCours[cle];
    enCours[cle] = candidats(c).then(function (liste) {
      var choix = choisir(liste, ecart);
      /* 28/09/2026 : une liste vide (réseau lent, limite de requêtes) n'est jamais gardée : on retentera */
      if (choix.length) {
        cache[cle] = choix;
        try { sessionStorage.setItem("nkV1Tous", JSON.stringify({ cle: cle, t: Date.now(), choix: choix })); } catch (x) {}
      }
      delete enCours[cle];
      return choix;
    }, function () { delete enCours[cle]; return []; });
    return enCours[cle];
  }
  function construire(bloc, choix) {
    bloc.innerHTML = "";
    var h = document.createElement("p");
    h.className = "nk-v1-atteindre__titre";
    h.textContent = T.titre;
    var ul = document.createElement("ul");
    ul.className = "nk-v1-atteindre__liste";
    ul.setAttribute("role", "list");
    choix.forEach(function (p) {
      var li = document.createElement("li");
      li.className = "nk-v1-atteindre__item";
      var img = document.createElement("img");
      img.className = "nk-v1-atteindre__img";
      img.width = 56; img.height = 56; img.alt = ""; img.loading = "lazy"; img.decoding = "async";
      if (p.img) img.src = p.img + (p.img.indexOf("?") < 0 ? "?" : "&") + "width=240";
      var milieu = document.createElement("div");
      var a = document.createElement("a");
      a.className = "nk-v1-atteindre__nom";
      a.href = p.url;
      a.textContent = String(p.nom || "").replace(/^(.+?, \d+ (?:produits?|products?|Produkte?|prodott[oi]))\b.*$/, "$1");
      var meta = document.createElement("span");
      meta.className = "nk-v1-atteindre__meta";
      var b = document.createElement("b");
      b.textContent = p.source === "rayon" ? (p.rang < 3 ? T.top : T.rayon) : (p.source === "lie" ? T.lie : T.vente);
      meta.appendChild(b);
      if (p.suffit) {
        var s = document.createElement("span");
        s.className = "nk-v1-atteindre__suffit";
        s.textContent = T.suffit;
        meta.appendChild(s);
      }
      milieu.appendChild(a);
      milieu.appendChild(meta);
      var droite = document.createElement("div");
      droite.className = "nk-v1-atteindre__droite";
      var prix = document.createElement("span");
      prix.className = "nk-v1-atteindre__prix";
      prix.textContent = euro(p.prix);
      var plus = document.createElement("button");
      plus.type = "button";
      plus.className = "nk-v1-atteindre__plus";
      plus.setAttribute("data-nk-v1-ajout", String(p.variante));
      plus.setAttribute("aria-label", T.ajouter + " : " + p.nom);
      plus.textContent = "+";
      droite.appendChild(prix);
      droite.appendChild(plus);
      li.appendChild(img); li.appendChild(milieu); li.appendChild(droite);
      ul.appendChild(li);
    });
    var tete = document.createElement("div");
    tete.className = "nk-v1-atteindre__tete";
    tete.appendChild(h);
    if (choix.length > 2) {
      var fl = document.createElement("div");
      fl.className = "nk-v1-atteindre__fleches";
      [["precedent", "\u2039", T.precedent], ["suivant", "\u203A", T.suivant]].forEach(function (x) {
        var f = document.createElement("button");
        f.type = "button";
        f.className = "nk-v1-atteindre__fleche";
        f.setAttribute("data-nk-v1-fleche", x[0]);
        f.setAttribute("aria-label", x[2]);
        f.textContent = x[1];
        fl.appendChild(f);
      });
      tete.appendChild(fl);
    }
    bloc.appendChild(tete);
    bloc.appendChild(ul);
    ul.addEventListener("scroll", function () { fleches(bloc); }, { passive: true });
    fleches(bloc);
  }
  /* flèches du carrousel (mobile) : grisées au début et à la fin de la liste */
  function fleches(bloc) {
    var ul = bloc.querySelector(".nk-v1-atteindre__liste");
    var b = bloc.querySelectorAll("[data-nk-v1-fleche]");
    if (!ul || !b.length) return;
    var fin = ul.scrollWidth - ul.clientWidth - 2;
    for (var i = 0; i < b.length; i++) {
      b[i].disabled = b[i].getAttribute("data-nk-v1-fleche") === "precedent" ? ul.scrollLeft <= 2 : ul.scrollLeft >= fin;
    }
  }
  document.addEventListener("click", function (e) {
    var f = e.target && e.target.closest && e.target.closest("[data-nk-v1-fleche]");
    if (!f) return;
    var bloc = f.closest(".nk-v1-atteindre");
    var ul = bloc && bloc.querySelector(".nk-v1-atteindre__liste");
    if (!ul) return;
    e.preventDefault();
    var doux = !(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    ul.scrollBy({ left: (f.getAttribute("data-nk-v1-fleche") === "suivant" ? 1 : -1) * Math.max(ul.clientWidth * 0.8, 120), behavior: doux ? "smooth" : "auto" });
  });

  /* tiroir Moon Bundles : le bloc est posé en fin de corps défilant (rien ne glisse au-dessus de lui) */
  var tiroirSig = "";
  function tiroir() {
    var d = document.getElementById("moonbundle-cart-drawer");
    if (!d) return;
    var corps = d.querySelector(".moonbundle-cart-body-scrollable");
    var articles = d.querySelector(".moonbundle-cart-body-items");
    var bloc = d.querySelector(".nk-v1-atteindre");
    var vide = !articles || !!d.querySelector(".moonbundle-cart-empty");
    if (!corps || vide || !panier || panier.total_price >= MINIMUM || !panier.item_count) {
      if (bloc) bloc.hidden = true;
      return;
    }
    if (!bloc) {
      bloc = document.createElement("div");
      bloc.className = "nk-v1-atteindre is-attente";
      bloc.setAttribute("data-nk-v1-contexte", "tiroir");
    }
    if (bloc.parentNode !== corps || corps.lastElementChild !== bloc) corps.appendChild(bloc);
    bloc.hidden = false;
    var sig = signature(panier);
    if (tiroirSig === sig && !bloc.classList.contains("is-attente")) return;
    tiroirSig = sig;
    suggestions(panier).then(function (choix) {
      if (!panier || signature(panier) !== sig) return;
      if (!choix.length) { bloc.hidden = true; return; }
      construire(bloc, choix);
      bloc.classList.remove("is-attente");
    });
  }

  /* page panier : conteneur rendu par le serveur (sections/main-cart.liquid), place gardée sous 39 € */
  function pagePanier() {
    var bloc = document.querySelector("[data-nk-v1-atteindre-page]");
    if (!bloc || !panier) return;
    if (panier.total_price >= MINIMUM || !panier.item_count) { bloc.hidden = true; return; }
    if (bloc.getAttribute("data-sig") === signature(panier)) return;
    var sig = signature(panier);
    bloc.setAttribute("data-sig", sig);
    suggestions(panier).then(function (choix) {
      if (!choix.length) { bloc.hidden = true; return; }
      construire(bloc, choix);
      bloc.classList.remove("is-attente");
      bloc.hidden = false;
    });
  }

  /* P3 : total de la barre fixe du panier (mobile) */
  function barre() {
    if (!panier) return;
    tous(document, "[data-nk-v1-barre-total]").forEach(function (el) { texte(el, euro(panier.total_price)); });
  }

  /* ajout : sans fermer le tiroir (moonbundle_ignore, voir le tiroir du panier vide), puis redessin sans glissement */
  var enTransition = false;
  function transitionTiroir() {
    var d = document.getElementById("moonbundle-cart-drawer");
    if (!d || enTransition || !d.classList.contains("open")) return;
    enTransition = true;
    var racine = document.documentElement, debut = Date.now(), calme = null, cadeaux = false, obs = null, plafond = null;
    function fin() {
      if (!enTransition) return;
      enTransition = false;
      if (obs) obs.disconnect();
      clearTimeout(calme); clearTimeout(plafond);
      window.removeEventListener("moonbundle-cart-updated", surCadeaux);
      racine.classList.remove("nk-pv-transition");
    }
    function relancer() {
      clearTimeout(calme);
      calme = setTimeout(function () { if (cadeaux || Date.now() - debut > 1200) fin(); else relancer(); }, 280);
    }
    function surCadeaux(e) { if (e && e.detail && e.detail.caller === "progressive-gifts") { cadeaux = true; relancer(); } }
    racine.classList.add("nk-pv-transition");
    window.addEventListener("moonbundle-cart-updated", surCadeaux);
    obs = new MutationObserver(relancer);
    obs.observe(d, { childList: true, subtree: true, characterData: true });
    plafond = setTimeout(fin, 2200);
    relancer();
  }
  function majCompteur(c) {
    tous(document, "[data-cart-count]").forEach(function (el) {
      if (c.item_count > 0) { el.style.display = ""; el.textContent = c.item_count < 100 ? String(c.item_count) : ""; }
      else { el.style.display = "none"; }
    });
  }
  function ajouter(b) {
    if (b.getAttribute("aria-busy") === "true") return;
    var surPage = !!b.closest("[data-nk-v1-atteindre-page]");
    b.setAttribute("aria-busy", "true");
    b.removeAttribute("data-etat");
    fetch(RACINE + "cart/add.js?moonbundle_ignore=true", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute("data-nk-v1-ajout")), quantity: 1 }] })
    }).then(function (r) {
      if (!r || !r.ok) throw new Error("HTTP " + (r && r.status));
      b.setAttribute("data-etat", "ok");
      b.textContent = "✓";
      if (surPage) { window.location.reload(); return; }
      return lirePanier(true).then(function (c) {
        if (!c) return;
        majCompteur(c);
        transitionTiroir();
        try {
          window.dispatchEvent(new CustomEvent("moonbundle-cart-updated", { detail: { cart: c, caller: "nkosi-vague1" } }));
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          document.dispatchEvent(new CustomEvent("nkosi:cart:added", { detail: { source: "vague1" } }));
        } catch (x) {}
      });
    }).catch(function () {
      b.setAttribute("data-etat", "erreur");
      b.setAttribute("title", T.erreur);
    }).then(function () {
      b.removeAttribute("aria-busy");
    });
  }
  document.addEventListener("click", function (e) {
    var b = e.target && e.target.closest && e.target.closest("[data-nk-v1-ajout]");
    if (!b) return;
    e.preventDefault();
    ajouter(b);
  });

  /* ---------- E1 : recherche de la page introuvable, remplie avec les mots de l'adresse demandée ----------
     (sur une 404, Shopify ne donne pas l'adresse demandée au gabarit ; /products/safou donne « safou ») */
  function recherche404() {
    var champ = document.getElementById("nk-v1-404-q");
    if (!champ || champ.value) return;
    var seg = decodeURIComponent((location.pathname.split("/").filter(Boolean).pop() || "")).replace(/[-_]+/g, " ");
    var mots = seg.split(/\s+/).filter(function (m) { return m.length >= 3 && !/^\d+$/.test(m); }).slice(0, 2);
    if (mots.length) champ.value = mots.join(" ");
  }

  /* ---------- orchestration ---------- */
  var prevu = false;
  function tout() {
    prevu = false;
    lots();
    if (panier) { tiroir(); pagePanier(); barre(); }
  }
  function prevoir() {
    if (prevu) return;
    prevu = true;
    (window.requestAnimationFrame || setTimeout)(tout);
  }
  function panierChange() {
    lirePanier(true).then(function () { prevoir(); });
  }
  function besoinPanier() {
    if (document.querySelector("[data-nk-v1-atteindre-page], [data-nk-v1-barre-total]")) return true;
    var n = document.querySelector("[data-cart-count]");
    return !!(n && parseInt(n.textContent, 10) > 0);
  }
  function demarrer() {
    recherche404();
    tout();
    if (besoinPanier()) lirePanier().then(prevoir);
    new MutationObserver(function (liste) {
      for (var i = 0; i < liste.length; i++) {
        var t = liste[i].target;
        if (t && t.closest && t.closest(".nk-v1-atteindre")) continue;
        prevoir();
        return;
      }
    }).observe(document.body, { childList: true, subtree: true });
    ["cart:updated", "cart:refresh", "nkosi:cart:added"].forEach(function (ev) {
      document.addEventListener(ev, function (e) { if (!(e.detail && e.detail.source === "vague1")) panierChange(); });
    });
    window.addEventListener("moonbundle-cart-updated", function (e) {
      if (e && e.detail && e.detail.cart && e.detail.cart.items) { panier = e.detail.cart; prevoir(); }
      else panierChange();
    });
    try {
      new PerformanceObserver(function (l) {
        if (l.getEntries().some(function (e) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(e.name); })) panierChange();
      }).observe({ type: "resource" });
    } catch (x) {}
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();
})();
